import React from 'react';
import Button from '../../../ui_kit/button/Button';
import styles from './SubmitIdea.module.sass';

function SubmitIdea() {
  return (
    <div className={styles['submit-idea']}>
      <div className={styles.background} />
      <div className={styles.title}>
        Have your own innovative beauty idea?
        <br />
        <span className={styles.desktop}>Submit your idea today.</span>
        <div className={styles.mobile}>
          Don’t see what you really want?
          <br />
          Take the quiz today.
        </div>
      </div>
      <Button
        className={styles.button}
        text="CREATE YOUR DREAM PRODUCT"
        color="transparent-white"
        size="small"
        href="/quizzes/"
      />
    </div>
  );
}

export default SubmitIdea;
